import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import CheckBox from '@components/@core/CheckBox';
import Dropdown from '@components/@core/Dropdown';
import EditDropdown from '@components/EditDropdown';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import { CONTENT_STATUS, SUPERADMIN_CONTENT_TYPE } from '~/services/constants';

const ContentHeader = () => (
    <div className="card-content">
        <div className="d-flex w-100 border-bottom pb-2 desktop-screen">
            <div className="d-flex-2">
                <span className="dsl-m12">Status/Type</span>
            </div>
            <div className="d-flex-3">
                <span className="dsl-m12">Title/Description</span>
            </div>
            <div className="d-flex-3">
                <span className="dsl-m12">Author</span>
            </div>
            <div className="d-flex-3">
                <span className="dsl-m12">Logged vs Moderated</span>
            </div>
            <div className="w30" />
        </div>
    </div>
);

const Content = ({ content, onChange }) => {
    const [search, setSearch] = useState('');

    const handlePage = (e) => {
        onChange({ page: e, per_page: 20 });
    };

    const handleSearch = (e) => {
        onChange({ search: e, page: 1, per_page: 20 });
        setSearch(e);
    };

    return (
        <>
            <div className="card-content d-flex py-4 ssm-column">
                <Input placeholder="Search here..." value={search} onChange={handleSearch} />
                <Button className="pl-2 ssp-l-0 ms-4 ssm-l-0 me-auto" name="SEARCH" type="link" />
                <Dropdown className="ml-4 ssm-l-0 content-drop" placeholder="Showing All" data={['']} getValue={(e) => e} />
            </div>
            <ContentHeader />
            {content.data.map((item, index) => {
                let cardClass = 'card';
                if (index % 20 === 0) {
                    cardClass = 'card-bottom';
                } else if (index % 20 === 19) {
                    cardClass = 'card-header';
                }
                const contentType = find(propEq('id', item.type), SUPERADMIN_CONTENT_TYPE);
                const { name, description, author_avatar, author, owner_avatar, last_edit, created_at, updated_at, status } = item;
                const contentStatus = CONTENT_STATUS[status];
                const lastEditor = `${last_edit?.user?.first_name || ''} ${last_edit?.user?.last_name || ''}`;
                return (
                    <div key={item.id} className={classNames('d-flex ssm-column', cardClass)}>
                        <div className="d-flex d-flex-2">
                            <div className="d-flex-2">
                                <CheckBox className={`content-checkbox ${contentStatus.value}`} title={contentStatus.title} checked={status === 0} />
                                <p className="dsl-m12 text-capitalize mb-0 ml30">{contentType.value}</p>
                            </div>
                            <EditDropdown className="mobile-screen" options={['']} />
                        </div>
                        <div className="d-flex-3">
                            <p className="dsl-b14 text-400">{name}</p>
                            <p className="dsl-m12 truncate-one">{description}</p>
                        </div>
                        <div className="d-flex d-flex-3">
                            <div className="d-flex-1">
                                <Avatar url={author_avatar || owner_avatar} />
                            </div>
                            <div className="d-flex-3">
                                <p className="dsl-b14 text-400">{`${author?.first_name || ''} ${author?.last_name || ''}`}</p>
                                <p className="dsl-b14 text-400">{author?.profile?.company}</p>
                                <p className="dsl-b14 text-400">192.168.0.1</p>
                            </div>
                        </div>
                        <div className="d-flex-3 mt-0 ssm-t-3">
                            <div className="d-flex ps-0 ssp-l-3">
                                <label className="mobile-screen dsl-b14 text-400 w-40">Logged</label>
                                <p className="dsl-b14 text-400">{moment(created_at).format('MMM DD, YY h:mma')}</p>
                            </div>
                            <div className="d-flex ps-0 ssp-l-3">
                                <label className="mobile-screen dsl-b14 text-400 w-40">Moderated</label>
                                <p className="dsl-b14 text-400">{moment(updated_at).format('MMM DD, YY h:mma')}</p>
                            </div>
                            <div className="d-flex ps-0 ssp-l-3">
                                <label className="mobile-screen dsl-b14 text-400 w-40">lastEditor</label>
                                <p className="dsl-b14 text-400">{lastEditor}</p>
                            </div>
                        </div>
                        <div className="w30 desktop-screen">
                            <EditDropdown options={['']} />
                        </div>
                    </div>
                );
            })}
            <Pagination className="card-content pb-2" current={content.current_page} total={content.last_page} per={content.per_page} pers={[]} onChange={handlePage} />
        </>
    );
};

Content.propTypes = {
    content: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
        per_page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        from: PropTypes.number,
        to: PropTypes.number,
        total: PropTypes.number,
    }),
    onChange: PropTypes.func,
};

Content.defaultProps = {
    content: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    onChange: () => {},
};

export default Content;
